// extracted by mini-css-extract-plugin
export default {"container":"Offerts_container__FUUZb","containerItems":"Offerts_containerItems__3EbFP","contentInfo":"Offerts_contentInfo__PbHa6","icons":"Offerts_icons__0CGm3"};